import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const About = ({ home }) => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("about");
      setDates(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!dates) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <div id="rs-about" class="rs-about about-shape">
        <div class="container">
          <div class="row rs-vertical-middle">
            <div class="col-lg-7">
              <div class="about-des">
                <div class="sec-title3 text-left">
                  <span>About Us</span>
                  <h2 className="text-blue">{dates.title[0]?.text}</h2>
                </div>
                {dates.description.map((para, index) => (
                  <p
                    key={index}
                    className=""
                    style={{ fontSize: dates.description[0]?.fontSize }}
                  >
                    {para.text}
                  </p>
                ))}
              </div>
              <section id="cmt-acknowledgement">
                <p>
                  The Microsoft CMT service was used for managing the
                  peer-reviewing process for this conference. This service was
                  provided for free by Microsoft and they bore all expenses,
                  including costs for Azure cloud services as well as for
                  software development and support.
                </p>
              </section>
            </div>
            <div class="col-lg-5 mmt-40">
              <div class="about-single-image text-right">
                <img
                  src="https://media.graphassets.com/resize=width:1472,height:792/2iZQyAS1uAW7AIr8RsRA"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cflex mx-5 px-5">
        <div class="pub_sec mx-4">
          <div class="container">
            <h2 class="text-blue text-center">Conference Details:</h2>
            {/* <h3 className="text-white text-center py-1 m-0">
              Conference Record Number:  {dates.record_number[0]?.text}
            </h3> */}
            <h3 className="text-white text-center py-1 m-0">
              Conference Venue:{" "}
              {/* <a
                href={dates.approval_link[0]?.text}
                target="_blank"
                rel="noopener noreferrer"
                class="text-blue text-center"
              >
                View Link
              </a> */}
              {home.location[0].text}
            </h3>
            {/* <p className="text-center">{dates.desc1[0]?.text}</p> */}
          </div>
        </div>
        <div class="pub_sec mx-4">
          <div class="container text-center">
            <h2 class="text-blue text-center">Previous Conference:</h2>
            <p className="text-center">{dates.desc2[0]?.text}</p>
            <p class="text-blue text-center">
              <a
                href={dates.title1[0]?.spans[1]?.data.url}
                class="text-blue text-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>{dates.title1[0]?.text}</strong>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
